/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { CardPackage, CardPointToPoint, CardWhatTheySay, CardWithDescription, CenteredRadiantGradient, MetaData, PackageSwiper, PackageSwiperBig, StyledButton } from '@/components/atoms'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { background_list, icon_list } from '@/assets/images'
import { useRef, useEffect } from 'react'
import { TitleImageDescSection } from '@/components/molecules'
import app_config from '@/constant/config'
import { getSeoMetadata } from '@/utility/apiProcess/seo/server'

export const getStaticProps = (async () => {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({ category_slug: 'pages', names: 'smm' })
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

  return {
    props: {
      seoMetadata: seoMetadata.data.result || {},
      ...(await serverSideTranslations(locale, [
        'smm',
      ]))
    }
  }
})

const SMM = (props) => {
  console.log('props', props)
  const { t } = useTranslation('smm')
  const router = useRouter()
  const what_is_data = [
    {
      title: t('smm.what_is'),
      description1: t('smm.what_is_desc'),
      description2: '',
      image: background_list.what_is_img_1
    },
    {
      title: t('smm.why_we'),
      description1: t('smm.why_we_desc'),
      description2: '',
      image: background_list.what_is_img_2
    },
  ]

  const swiperData = [
    {
      title: "Starter Package",
      image: background_list.sila,
      onClick: () => {
        window.fbq('track', 'Add To Cart', { content_name: router.route })
        router.push(route_list.register)
      },
      buttonLabel: t('smm.add_cart'),
      price: 'Rp 10.000.000',
      description: [
        '12x Content Video (TikTok)',
        '12x IG Reels/Shopee (mirroring Tiktok)',
        '15x IG Feeds (caption + hashtag)',
        '1-2x Photoshoot',
        '2x Shooting session (1 session for 6 video takes)',
        'Monthly Report',
        'Goals ads to sales (est. result:)',
      ]
    },
    {
      title: "Relevant Package",
      image: background_list.sila7,
      onClick: () => {
        window.fbq('track', 'Add To Cart', { content_name: router.route })
        router.push(route_list.register)
      },
      buttonLabel: t('smm.add_cart'),
      price: 'Rp 7.000.000',
      description: [
        '12x Content Video (TikTok)',
        '12x IG Reels/Shopee (Mirroring Tik Tok)',
        '2x Shooting session (1 session for 6 video takes)',
        'Monthly Report',
        'Goals ads to sales (est, result:)',
      ]
    },
    {
      title: "Impactful Package",
      image: background_list.sila2,
      onClick: () => {
        window.fbq('track', 'Add To Cart', { content_name: router.route })
        router.push(route_list.register)
      },
      buttonLabel: t('smm.add_cart'),
      price: 'Rp 8.000.000',
      description: [
        '12x Content Video (TikTok)',
        '12x IG Reels/Shopee (Mirroring TikTok)',
        '4x IG Feeds (caption + hashtags)',
        '1x Photoshoot',
        '2x Shooting session (1 session for 6 video takes)',
        'Monthly Report',
        'Goals ads to sales (est, result:)',
      ]
    },
    {
      title: "Premium Relevant Package",
      image: background_list.sila3,
      onClick: () => {
        window.fbq('track', 'Add To Cart', { content_name: router.route })
        router.push(route_list.register)
      },
      buttonLabel: t('smm.add_cart'),
      price: 'Rp 9.000.000',
      description: [
        '12 Tiktok Videos (with Lens Camera)',
        'Lens Camera'
      ]
    },
    {
      title: "Premium Impactful Package",
      image: background_list.sila4,
      onClick: () => {
        window.fbq('track', 'Add To Cart', { content_name: router.route })
        router.push(route_list.register)
      },
      buttonLabel: t('smm.add_cart'),
      price: 'Rp 10.000.000',
      description: [
        '12 Tiktok Videos (with Lens Camera)',
        '12 Instagram Reels (Mirroring TikTok)',
        '4 Instagram Feeds',
        'Lens Camera',
        '1x Photoshoot'
      ]
    },
  ]

  const swiperData2 = [
    {
      title: "Live Shopping",
      onClick: () => router.push(route_list.live_shopping),
      buttonLabel: t('smm.learn_more'),
    },
    {
      title: "Influencer Endorsement",
      onClick: () => router.push(route_list.endorsement),
      buttonLabel: t('smm.learn_more'),
    },
    {
      title: "Enterprise Solution",
      onClick: () => window.open(app_config.enterpriseUrl),
      buttonLabel: t('smm.learn_more'),
    },
  ]

  const swiperTestimony = [
    {
      description: `"${t('smm.testimoni1')}"`,
      photo: background_list.raga,
      name: "Raga Hariawan",
      position: "Senior Content Specialist @ Bukalapak"
    },
    {
      description: `"${t('smm.testimoni2')}"`,
      photo: background_list.vicky,
      name: "Vicky Kurniawan",
      position: "Founder @ Kibocheese"
    },
  ]

  const stepData = [
    {
      title: t('smm.how_1'),
      description: t('smm.how_1_desc')
    },
    {
      title: t('smm.how_2'),
      description: t('smm.how_2_desc')
    },
    {
      title: t('smm.how_3'),
      description: t('smm.how_3_desc')
    }
  ]

  const howAreWeData = {
    title: t('smm.how_are_we'),
    description: t('smm.how_are_we_desc'),
    image: background_list.how_are_we,
    points: [
      {
        title: t('smm.hw1'),
        description: t('smm.hw1_desc')
      },
      {
        title: t('smm.hw2'),
        description: t('smm.hw2_desc')
      },
      {
        title: t('smm.hw3'),
        description: t('smm.hw3_desc')
      },
      {
        title: t('smm.hw4'),
        description: t('smm.hw4_desc')
      },
    ]
  }

  return (
    <div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
      <div className='tw-newsroom-banner' id='newsroom-banner'>
        <div className='tw-m-auto md:tw-py-16 tw-py-8 md:tw-px-0 tw-px-4 tw-max-w-6xl tw-mx-auto tw-grid md:tw-grid-cols-2 tw-gap-2'>
          <div>
            <h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 md:tw-text-left tw-text-center'>
              Social Media Management
            </h2>
            <span className='tw-text-white tw-text-sm md:tw-text-justify tw-flex tw-text-center'>
              {t('smm.description')}
            </span>
            <div className='md:tw-flex tw-hidden tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton onClick={() => window.open(app_config.AndroidClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.playstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
              <StyledButton onClick={() => window.open(app_config.AppstoreClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.appstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
            </div>
          </div>
          <div className='tw:w-full tw-flex tw-flex-col tw-items-center tw-justify-center'>
            <Image src={background_list.smm_head} alt='' className='md:tw-w-[50%] tw-w-[50%]' />
            <div className='md:tw-hidden tw-flex tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton onClick={() => window.open(app_config.AndroidClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.playstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
              <StyledButton onClick={() => window.open(app_config.AppstoreClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.appstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
            </div>
          </div>
        </div>
      </div>
      <div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px] tw-overflow-hidden'>
        <div className='tw-newsroom-container'>
          <div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:tw-px-0 tw-px-4 tw-text-justify'>
            {/* What is */}
            <CardWithDescription data={what_is_data} />
            {/* How It Works */}
            <div className='tw-mb-20'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 tw-mt-20 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-left  tw-w-fit tw-pb-1'>{t('smm.how_it')}</h1>
              <p className='tw-text-left tw-mb-10'>
                {t('smm.how_it_desc')}
              </p>
              <div className="tw-flex tw-items-center tw-font-poppins tw-rounded-lg ">
                <div className="tw-justify-center tw-flex-1 tw-max-w-6xl ">
                  <CardPointToPoint data={stepData} className="md:tw-grid-cols-3" />
                </div>
              </div>
            </div>
            {/* Why Choose  Social Bread? */}
            <TitleImageDescSection data={howAreWeData} />
            {/* Our Packages */}
            <div className=' tw-mb-12'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-center tw-pb-1'>{t('smm.our_packages')}</h1>
              <PackageSwiperBig data={swiperData} titleClass="tw-text-center" />
            </div>
            {/* What They Say */}
            <div className='tw-my-20'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-left tw-pb-1'>{t('smm.what_they_say')}</h1>
              <CardWhatTheySay data={swiperTestimony} />
            </div>
            {/* Other Services */}
            <div className='tw-my-28'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-center tw-pb-1'>{t('smm.other_service')}</h1>
              <div className='tw-relative'>
                <CenteredRadiantGradient />
                <div className='md:tw-block tw-hidden'>
                  <PackageSwiper data={swiperData2} cardClass="tw-min-h-[250px]" titleClass="tw-text-left tw-my-0 tw-px-20" />
                </div>
                <div className='tw-block md:tw-hidden'>
                  <CardPackage data={swiperData2} cardClass="tw-min-h-[250px] tw-p-10" devide={false} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SMM

// export async function getServerSideProps({ locale }: any) {
// 	return {
// 		props: {
// 			...(await serverSideTranslations(locale, ['footer', 'navbar', 'privacy-policy'])),
// 		},
// 	}
// }
